"use client";

import Header from "@/app/components/layout/Header";

import { useHeader } from "@/contexts/header";

export default function HeaderWrapper() {
  const { isHeaderVisible } = useHeader();
  
  if (!isHeaderVisible) {
    return null;
  }
    return <Header />
}
